(() => {
  'use strict';
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let userPaused = false;
  try { userPaused = localStorage.getItem('skyllo-motion') === 'paused'; } catch (_) {}
  const updateMotion = () => {
    const paused = userPaused || motionQuery.matches;
    document.documentElement.classList.toggle('sky-paused', paused);
    document.documentElement.classList.toggle('sky-js-motion', !paused);
    document.querySelectorAll('[data-motion-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', motionQuery.matches ? 'Animacje wyłączone w ustawieniach systemowych' : paused ? 'Włącz animacje' : 'Wyłącz animacje');
      button.innerHTML = paused ? '<svg class="sky-icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5"><path d="m8 5 11 7-11 7Z"/></svg>' : '<svg class="sky-icon" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M9 5v14M15 5v14"/></svg>';
    });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } });
  }, { threshold: 0.08, rootMargin: '0px 0px 24px 0px' }) : null;
  const init = (root = document) => {
    root.querySelectorAll('.sky-reveal').forEach(el => observer ? observer.observe(el) : el.classList.add('is-visible'));
    updateMotion();
  };
  document.addEventListener('click', event => {
    const motionButton = event.target.closest('[data-motion-toggle]');
    if (motionButton) { userPaused = !userPaused; try { localStorage.setItem('skyllo-motion', userPaused ? 'paused' : 'running'); } catch (_) {} updateMotion(); }
    const filter = event.target.closest('[data-filter]');
    if (filter) {
      const catalog = filter.closest('.sky-catalog');
      catalog.querySelectorAll('[data-filter]').forEach(button => { const active = button === filter; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
      catalog.querySelectorAll('[data-category]').forEach(card => { card.hidden = filter.dataset.filter !== 'all' && filter.dataset.filter !== card.dataset.category; if (!card.hidden) card.classList.add('is-visible'); });
    }
    const mobileLink = event.target.closest('.sky-mobile-menu a');
    if (mobileLink) mobileLink.closest('details').open = false;
    const demoLink = event.target.closest('[data-demo-product]');
    if (demoLink) {
      event.preventDefault();
      let dialog = document.querySelector('.sky-demo-dialog');
      if (!dialog) {
        dialog = document.createElement('dialog'); dialog.className = 'sky-demo-dialog'; dialog.setAttribute('aria-labelledby', 'sky-demo-heading');
        dialog.innerHTML = '<button class="sky-demo-close" aria-label="Zamknij">✕</button><span class="sky-demo-label">PODGLĄD PROJEKTU · PRZYKŁADOWY PRODUKT</span><h2 id="sky-demo-heading"></h2><p></p><p style="margin-top:18px">To przykład prezentacji kursu. Docelowo karta otworzy stronę Twojego produktu w Shopify z opisem, ceną i możliwością zakupu.</p><button class="sky-button sky-button-dark sky-demo-back">Wróć do odkrywania ↗</button>';
        document.body.append(dialog);
        dialog.querySelectorAll('button').forEach(button => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('click', event => { if(event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if(event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
      }
      const card = demoLink.closest('.sky-product-card');
      dialog.querySelector('h2').textContent = card.querySelector('h3').textContent;
      dialog.querySelector('p').textContent = card.querySelector(':scope > p').textContent;
      dialog.showModal();
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('.sky-reveal').forEach(el => el.classList.add('is-visible')));
  motionQuery.addEventListener('change', updateMotion);
  init();
})();
